import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { accountsEnvironment } from './accounts-environment';
import { configSettingsDataSchema } from './schemas/config-settings-data.schema';

export function getConfigSettings(accountAlias: string) {
  return fromFetch(
    new Request(accountsEnvironment.configSettingsAccountUrl(accountAlias), {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
    })
  ).pipe(selectData(configSettingsDataSchema));
}
